"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _effects = require("redux-saga/effects");

var _apiHelper = require("../api/api-helper");

var _primaryCustomerDataActions = require("../actions/primaryCustomerDataActions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchPrimaryCustomerData);

function fetchPrimaryCustomerData() {
    var authToken, locale, bookingMeta, primaryCustomerId, _ref, primaryCustomerData, error;

    return _regenerator2.default.wrap(function fetchPrimaryCustomerData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return (0, _effects.take)(_primaryCustomerDataActions.PRIMARY_CUSTOMER_DATA_REQUESTED);

                case 2:
                    _context.next = 4;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 4:
                    authToken = _context.sent;
                    _context.next = 7;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 7:
                    locale = _context.sent;
                    _context.next = 10;
                    return (0, _effects.select)(function (state) {
                        return state.bookingMeta;
                    });

                case 10:
                    bookingMeta = _context.sent;
                    primaryCustomerId = _lodash2.default.get(bookingMeta, "primary_customer.id", null);

                    if (primaryCustomerId) {
                        _context.next = 16;
                        break;
                    }

                    _context.next = 15;
                    return (0, _effects.put)((0, _primaryCustomerDataActions.primaryCustomerDataRequestFailed)("Failed to request primary customer data. No customer ID found in booking meta data."));

                case 15:
                    return _context.abrupt("return");

                case 16:
                    _context.next = 18;
                    return (0, _apiHelper.getPrimaryCustomerData)(primaryCustomerId, authToken, locale);

                case 18:
                    _ref = _context.sent;
                    primaryCustomerData = _ref.primaryCustomerData;
                    error = _ref.error;

                    if (!primaryCustomerData) {
                        _context.next = 26;
                        break;
                    }

                    _context.next = 24;
                    return (0, _effects.put)((0, _primaryCustomerDataActions.primaryCustomerDataReceived)(primaryCustomerData));

                case 24:
                    _context.next = 28;
                    break;

                case 26:
                    _context.next = 28;
                    return (0, _effects.put)((0, _primaryCustomerDataActions.primaryCustomerDataRequestFailed)(error));

                case 28:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchPrimaryCustomerData;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchPrimaryCustomerData.js
// module id = 1414
// module chunks = 0